import React from 'react';

import NetworkElementsForm, {
	INetworkElementsFormProps,
} from '@components/routes/AdminPanel/ManageNetworkElements/NetworkElementsForm/NetworkElementsForm';

import useQueryAutoSwitchAvailable from '@hooks/networkElements/useQueryAutoSwitchAvailable';

import { INetworkElementDTO } from '@interfaces/networkElements/dto/networkElements';

function EditNetworkElementsForm({
	networkElement,
	handleCheckName,
	handleCheckIpAddress,
	setIsDirtyForm,
	onEditNetworkElement,
	isLoadingForm,
}: Omit<INetworkElementsFormProps, 'submitHandler'> & {
	onEditNetworkElement: (networkElement: INetworkElementDTO) => void;
}) {
	const { isAutoSwitchAvailable, isLoadingAutoSwitchAvailable } = useQueryAutoSwitchAvailable(networkElement?.id);

	return (
		<NetworkElementsForm
			handleCheckIpAddress={handleCheckIpAddress}
			handleCheckName={handleCheckName}
			isLoadingAutoSwitchAvailable={isLoadingAutoSwitchAvailable}
			isLoadingForm={isLoadingForm}
			networkElement={networkElement}
			setIsDirtyForm={setIsDirtyForm}
			submitHandler={onEditNetworkElement}
			withAutoSwitch={isAutoSwitchAvailable}
		/>
	);
}

export default EditNetworkElementsForm;
